export const PASSWORD_REQUIREMENTS_MESSAGE =
    'At least 6 characters, including an uppercase letter, a lowercase letter, a number, and a special character';

export const isStrongPassword = (password) => {
    if (typeof password !== 'string' || password.length < 6) return false;
    const hasUpper = /[A-Z]/.test(password);
    const hasLower = /[a-z]/.test(password);
    const hasDigit = /\d/.test(password);
    const hasSpecial = /[^A-Za-z0-9]/.test(password);
    return hasUpper && hasLower && hasDigit && hasSpecial;
};
